
import {Component, Vue} from 'vue-property-decorator'
import {getOrderNodeListAll, ShopOrderNodeListDto} from "@/api/shopOrder";

@Component({
    name: 'OrderNode',
})
export default class OrderNode extends Vue {
    showTemp = false
    nodeList: ShopOrderNodeListDto[] = []
    params = {
        orderId: '',
        orderType: null, // 1：订货单 2：退货单
        currRouteId: null
    }
    title = ''

    show(data: { orderId?: string; orderType?: number; currRouteId?: number }) {
        this.showTemp = true
        this.params.orderId = data.orderId
        this.params.orderType = data.orderType
        this.params.currRouteId = data.currRouteId
        this.title = data.orderType === 1 ? '订单节点' : '退货单节点'
        this.getNodeList()
    }

    getNodeList() {
        getOrderNodeListAll(this.params).then((res) => {
            this.nodeList = res.data || []
        })
    }

}
